<template>
  <div class="_rfp_mctb_cm_01_ rfp-mctb-carousel-mode-header vue-tabs">
    <div class="_rfp_mctb_cm_02_ rfp-mctb-carousel-mode-header-top-header">
      {{ carouselHeaderText }}
    </div>
    <div class="_rfp_mctb_list_006_ nav-tabs-navigation">
      <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
        <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
          <template v-if="storeLocatorModeOptions.CountryList.length != 0">
            <li
              v-for="(x, index) in storeLocatorModeOptions.CountryList"
              :id="x.DisplayName"
              :key="x.DisplayName"
              name="tab"
              aria-selected="true"
              :aria-controls="x"
              role="tab"
              class="_rfp_mctb_list_009_ tab active"
              :class="{ active__tab: index === tabIndex }"
              @click="tabEnable(x, index)"
            >
              <span role="tab" class="_rfp_mctb_list_0010_ active_tab tabs__link">
                <span class="_rfp_mctb_list_0011_ title title_center">
                  {{ x.DisplayName }}
                </span>
              </span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <template v-if="storeLocatorModeOptions.CountryList.length != 0">
      <template v-for="(item, index) in storeLocatorModeOptions.CountryList">
        <rfp-mctb-carousel
          v-if="index === tabIndex && item.Name === tabValue.Name"
          :key="item.Name"
          :enable-rtl="enableRtl"
          :autoplay="false"
          :autoplay-timeout="10000"
          :loop="false"
          :autoplay-hover-pause="true"
          :min-swipe-distance="8"
          pagination-active-color="#f30606"
          pagination-color="#efefef"
          :pagination-padding="10"
          :pagination-size="10"
          :per-page="1"
          :navigation-enabled="true"
          :pagination-enabled="false"
          :productname="productname"
          :productids="productids"
        >
          <template v-for="x in storeLocatorModeOptions.Product.Retailers">
            <rfp-mctb-slide v-if="x.Country === item.Name" :key="x.Name" :enable-rtl="enableRtl">
              <div class="_rfp_mctb_cm_03_ rfp-mctb-slider-outer">
                <div class="_rfp_mctb_cm_04_ rfp-mctb-slider-description rfp-mctb-image-alignment">
                  <img
                    class="_rfp_mctb_cm_05_ rfp-mctb-button-image"
                    :src="x.Logo"
                    :alt="x.LogoAlt"
                  />
                </div>
                <p class="_rfp_mctb_cm_06_ rfp-mctb-slider-description" v-html="x.Description"></p>
                <button
                  class="_rfp_mctb_cm_07_ rfp-mctb-common-buynow"
                  @click="
                    pageRedirectUrl(
                      x.RetailerUrl,
                      x.OpenInNewWindow,
                      x.RetailerTags,
                      x.RetailerTagsGS,
                      x.Name,
                    )
                  "
                >
                  <span class="_rfp_mctb_cm_08_ rfp-mctb-button-text"> {{ x.Name }} </span>
                </button>
              </div>
            </rfp-mctb-slide>
          </template>
        </rfp-mctb-carousel>
      </template>
      <template v-if="tabRetailerList.length === 0">
        <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
          <ul class="_rfp_mctb_list_0013_">
            <li class="retailer__unavailable">
              <div class="retailer-unavailable_01">
                {{ retailerUnavailable }}
              </div>
            </li>
          </ul>
        </section>
      </template>
    </template>
    <template v-if="storeLocatorModeOptions.CountryList.length === 0">
      <rfp-mctb-carousel
        :enable-rtl="enableRtl"
        :autoplay="false"
        :autoplay-timeout="10000"
        :loop="false"
        :autoplay-hover-pause="true"
        :min-swipe-distance="8"
        pagination-active-color="#f30606"
        pagination-color="#efefef"
        :pagination-padding="10"
        :pagination-size="10"
        :per-page="1"
        :navigation-enabled="true"
        :pagination-enabled="false"
        :productname="productname"
        :productids="productids"
      >
        <rfp-mctb-slide
          v-for="x in storeLocatorModeOptions.Product.Retailers"
          :key="x.Name"
          :enable-rtl="enableRtl"
        >
          <div class="_rfp_mctb_cm_03_ rfp-mctb-slider-outer">
            <div class="_rfp_mctb_cm_04_ rfp-mctb-slider-description rfp-mctb-image-alignment">
              <img class="_rfp_mctb_cm_05_ rfp-mctb-button-image" :src="x.Logo" :alt="x.LogoAlt" />
            </div>
            <p class="_rfp_mctb_cm_06_ rfp-mctb-slider-description" v-html="x.Description"></p>
            <button
              class="_rfp_mctb_cm_07_ rfp-mctb-common-buynow"
              @click="
                pageRedirectUrl(
                  x.RetailerUrl,
                  x.OpenInNewWindow,
                  x.RetailerTags,
                  x.RetailerTagsGS,
                  x.Name,
                )
              "
            >
              <span class="_rfp_mctb_cm_08_ rfp-mctb-button-text"> {{ x.Name }} </span>
            </button>
          </div>
        </rfp-mctb-slide>
      </rfp-mctb-carousel>
      <template v-if="storeLocatorModeOptions.Product.Retailers.length === 0">
        <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
          <ul class="_rfp_mctb_list_0013_">
            <li class="retailer__unavailable">
              <div class="retailer-unavailable_01">
                {{ retailerUnavailable }}
              </div>
            </li>
          </ul>
        </section>
      </template>
    </template>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpMctbCarousel from '../rfp-mctb-slider/rfp-mctb-carousel.vue';
import RfpMctbSlide from '../rfp-mctb-slider/rfp-mctb-slide.vue';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-carousel-mode',
  components: {
    RfpMctbCarousel,
    RfpMctbSlide,
  },
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: false,
    },
    carouselHeaderText: {
      type: String,
      default: 'Choose a Retailer',
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      eventProjectDataLayer: {},
      tabIndex: null,
      tabValue: null,
      areaValue: true,
      tabRetailerList: [],
    };
  },
  created() {
    if (this.storeLocatorModeOptions.CountryList.length !== 0) {
      this.tabEnable(this.storeLocatorModeOptions.CountryList[0], 0);
    }
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(
          `error/rfp-mctb-carousel-mode#pageRedirectUrl: ${service} tag parsing failed`,
          e,
        );
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    tabEnable(item, index) {
      this.tabRetailerList = [];
      for (const retailer of this.storeLocatorModeOptions.Product.Retailers) {
        retailer.Country === item.Name && this.tabRetailerList.push(retailer);
      }
      this.tabIndex = index;
      this.tabValue = item;
    },
  },
};
</script>
